<template>
    <div class="row mb-4">
        <div class="col-md-3 mb-4">
            <label class="form-label" for="is_iplicit">In Iplicit</label>
            <select class="form-select" id="is_iplicit" v-model="filters.is_iplicit">
                <option value="">All</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
            </select>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search credit note number...">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <th v-if="props.hideCentre === false">Centre</th>
            <th v-if="props.hideOrganisation === false">Organisation</th>
            <th v-if="props.hideCustomer === false">Customer</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="credit_note_date">Credit Note Date</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="cinolla_credit_note_number">Credit Note Number</sortableTh>
            <th>Credit Note Reference</th>
            <th>Invoice Number</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="total_gross">Total Gross</sortableTh>
            <th>Iplicit Status</th>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="creditNote in data" :key="creditNote.id">
                <td v-if="props.hideCentre === false">{{ creditNote.centre_name }}</td>
                <td v-if="props.hideOrganisation === false">{{ creditNote.organisation_name }}</td>
                <td v-if="props.hideCustomer === false">{{ creditNote.customer_name }}</td>
                <td>{{ creditNote.credit_note_date }}</td>
                <td>{{ creditNote.cinolla_credit_note_number }}</td>
                <td>{{ creditNote.cinolla_booking_reference }}</td>
                <td>{{ creditNote.cinolla_invoice_number }}</td>
                <td>{{ creditNote.total_gross }}</td>
                <td>{{ creditNote.iplicit_credit_note_status }}</td>
                <td v-html="creditNote.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
    hideCentre: Boolean,
    hideCustomer: Boolean,
    hideOrganisation: Boolean,
});

const orderBy = ref('credit_note_date');
const orderAsc = ref(false);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    is_iplicit: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
